/* ==========================================================================
   SHIRTPLUS — SP-800-029: AVIS-Aufpreishinweis, Sekundaerzeile (rein additiv)
   ==========================================================================
   Ergaenzt den von der AvisPlus-App gerenderten Aufpreis-Hinweis
   (`.avp-productoption-total-add`, siehe assets/sp-avis-price-notice.css)
   um eine zweite, erklaerende Textzeile ("Der Aufpreis wird automatisch im
   Warenkorb beruecksichtigt."). Der Titeltext und der dynamische Preis der
   App werden dabei NIEMALS gelesen, veraendert oder ueberschrieben - dieses
   Skript haengt ausschliesslich ein zusaetzliches, eigenes <span>-Element
   mit statischem Text an das Ende des App-Containers an.

   GRUND FUER JS STATT REINEM CSS
   Ticket Abschnitt 8 (Accessibility) untersagt bedeutungstragenden Inhalt
   ausschliesslich ueber CSS-Pseudoelemente. Der Zusatztext muss daher ein
   echter DOM-Textknoten sein (von Screenreadern vorlesbar), kein
   ::after-content.

   SELBSTHEILEND
   Reagiert per MutationObserver auf jede Neuzusammensetzung des
   AVIS-Containers (z. B. bei Optionswechsel, wenn AVIS den Preis neu
   berechnet und den Container-Inhalt neu rendert) und ergaenzt die Zeile bei
   Bedarf erneut. Doppelte Einfuegung wird ueber einen querySelector-Check
   verhindert (kein rekursiver Trigger durch die eigene DOM-Aenderung).

   SICHERHEIT
   Greift NICHT in AVIS-Berechnungslogik, Warenkorb-Integritaetslogik oder
   Produktdaten ein - rein additive DOM-Kosmetik innerhalb des
   AVIS-Konfigurationsmodals. Kein Lesen/Schreiben von Preisen oder Mengen.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__spAvisPriceNoticeLoaded) return;
  window.__spAvisPriceNoticeLoaded = true;

  var NOTE_TEXT = 'Der Aufpreis wird automatisch im Warenkorb berücksichtigt.';
  var NOTE_CLASS = 'sp-avis-price-note';
  var TARGET_SELECTOR = '.avp-productoption-total-add';

  function enhance(el) {
    if (!el || !el.isConnected) return;
    if (el.querySelector('.' + NOTE_CLASS)) return; // bereits ergaenzt
    if (!el.textContent || !el.textContent.trim()) return; // (noch) kein Aufpreis > 0

    var note = document.createElement('span');
    note.className = NOTE_CLASS;
    note.textContent = NOTE_TEXT;
    el.appendChild(note);
  }

  function scan(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    root.querySelectorAll(TARGET_SELECTOR).forEach(enhance);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];

      if (m.target && m.target.nodeType === 1 && m.target.classList &&
          m.target.classList.contains('avp-productoption-total-add')) {
        enhance(m.target);
      }

      for (var j = 0; j < m.addedNodes.length; j++) {
        var node = m.addedNodes[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches(TARGET_SELECTOR)) enhance(node);
        scan(node);
      }
    }
  });

  function start() {
    scan(document);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
